import { defineComponent } from 'vue'
import Tabbar from '../Tabbar'
import { useRoute } from 'vue-router'

export default defineComponent({
  setup() {
    // const route = useRoute()

    return () => (
      <router-view />
      // <div>
      //    {route.meta.showTab && <Tabbar />}
      //  </div>
    )
  }
})
